/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { apiSlice } from "@/services/http";
import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { excludedRoutes } from "./public-route-map";

const AccessContext = createContext({});

interface PrivateRouteProps {
  children: ReactNode;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const user = localStorage.getItem("@azure:user");
  const token = localStorage.getItem("@azure:token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [isAuthenticated, setIsAuthenticated] = useState(!!user && !!token);

  const isExcluded = excludedRoutes.includes(location.pathname);

  useEffect(() => {
    if (!isExcluded) {
      if (!token || !user) {
        dispatch(apiSlice.util.resetApiState());
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    }
  }, [token, user, dispatch, isExcluded]);

  useEffect(() => {
    if (!isExcluded && !isAuthenticated) {
      if (import.meta.env.VITE_REACT_ENV === "development" || import.meta.env.NODE_ENV === "homolog") {
        navigate("/login");
      } else {
        console.log("Usuário não autenticado - homolog/production");
      }
    }
  }, [isAuthenticated, navigate, isExcluded]);

  return <AccessContext.Provider value={{}}>{children}</AccessContext.Provider>;
};

export const useAccess = () => useContext(AccessContext);
